import api from "./api";

const { productServiceAPI } = api;

const PACKAGING_ONLOAD_PATH = "/product/specification/packaging/onload";

const PackagingOnloadService = {
  getOnload: async (type?: string): Promise<any> => {
    console.log({type})
    try {
      const query = type ? type : "";
      const resp = await productServiceAPI.get(`${PACKAGING_ONLOAD_PATH}${query}`);
      return resp.data;
    } catch (error) {
      throw error;
    }
  }
};

export default PackagingOnloadService;


